<form [formGroup]="formGroup">
  @for (element of elements; track element) {
    @if (element.type === "section") {
      @if (page.name === "page7" && element.name == "question442") {
        <br />
        <div class="indent">
          <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="4px">
            <p>
              <strong>{{ "oralTrials.title" | translate }}</strong>
            </p>

            <div class="indent">
              <ul>
                <li *ngFor="let item of 'oralTrials.items' | translate">
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      }
      <div class="section">
        <b class="section-title">{{ element.title }}</b>
      </div>
    }

    @if (element.type === "text") {
      <div class="text-row">
        <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
          <div
            fxLayout="col"
            fxFlex="100"
            class="add-patient-col"
            fxLayoutAlign="start center"
          >
            <!--  <b class="title">{{ element.title }}</b> -->
            <b class="title">{{ element.title }}</b>
            <!-- Quick Action Button for "Not mentioned" -->
            @if (!readonlyMode && (isInpatientView() || isEOC())) {
              <button
                nz-button
                nzType="primary"
                (click)="setNotMentioned(element.name)"
                class="quick-button"
                [disabled]="!hasPermission(['a-sqa'])"
              >
                {{ "Not mentioned" | translate }}
              </button>
            }
          </div>
        </div>
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          class="add-patient-row"
        >
          <div fxLayout="col" fxFlex="100" class="add-patient-col">
            <input
              type="text"
              class="add-patient-input"
              [formControlName]="element.name"
            />
          </div>
        </div>
      </div>
    }
    @if (element.type === "boolean") {
      <div class="q-row">
        <div class="q-label">
          <b class="title">{{ element.title }}</b>
        </div>

        <div class="q-control a-index">
          <nz-radio-group
            class="boolean-segment"
            [nzButtonStyle]="'solid'"
            [formControlName]="element.name"
          >
            <label
              nz-radio-button
              [nzValue]="false"
              (click)="onRadioClick(element.name, false)"
            >
              <span>{{ element.labelFalse }}</span>
            </label>

            <label
              nz-radio-button
              [nzValue]="true"
              (click)="onRadioClick(element.name, true)"
            >
              <span>{{ element.labelTrue }}</span>
            </label>
          </nz-radio-group>
        </div>
      </div>
    }
    @if (element.type === "radiogroup") {
      <div class="q-row q-row--radiogroup">
        <div class="q-label">
          <b class="title">{{ element.title }}</b>
        </div>

        <div class="q-control q-control--radiogroup a-index">
          <nz-radio-group
            [nzButtonStyle]="'solid'"
            [formControlName]="element.name"
          >
            @for (choice of element.choices; track choice) {
              <label
                nz-radio-button
                [nzValue]="choice.value"
                (click)="onRadioClick(element.name, choice.value)"
              >
                {{ choice.text }}
              </label>
            }
          </nz-radio-group>
        </div>
      </div>
    }
    @if (element.type === "comment") {
      @if (page.name === "page7") {
        <br />
        <div class="indent">
          <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="4px">
            <p>{{ "OcadRecommendationNotes.title" | translate }}</p>

            <div class="indent">
              <h4 class="indent">
                <u>{{ "OcadRecommendationNotes.sectionTitle" | translate }}</u>
              </h4>

              <p class="indent">
                {{ "OcadRecommendationNotes.positioning" | translate }}
              </p>
              <p class="indent">
                {{ "OcadRecommendationNotes.swallowing" | translate }}
              </p>
              <p class="indent">
                {{ "OcadRecommendationNotes.sensory" | translate }}
              </p>
              <p class="indent">
                {{ "OcadRecommendationNotes.other" | translate }}
              </p>
            </div>
          </div>
        </div>
      }
      <div>
        <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
          <div
            fxLayout="col"
            fxFlex="100"
            class="add-patient-col"
            fxLayoutAlign="start center"
          >
            <b class="title">{{ element.title }}</b>
            <!-- Quick Action Button for "Not mentioned" -->
            @if (!readonlyMode && (isInpatientView() || isEOC())) {
              <button
                nz-button
                nzType="primary"
                (click)="setNotMentioned(element.name)"
                class="quick-button"
                [disabled]="!hasPermission(['a-sqa'])"
              >
                {{ "Not mentioned" | translate }}
              </button>
            }
          </div>
        </div>
        <div
          fxLayout="row"
          fxLayoutAlign="center center"
          class="add-patient-row"
        >
          <div fxLayout="col" fxFlex="100" class="add-patient-col">
            <textarea
              class="add-patient-input textarea-input"
              [formControlName]="element.name"
            ></textarea>
          </div>
        </div>
      </div>
    }
  }
</form>
